import { useTranslation } from '@/hooks/useTranslation';
import { useReveal } from '@/hooks/useReveal';

const TechStackSection = () => {
  const { t } = useTranslation();
  useReveal();

  return (
    <section id="tech">
      <div className="tech-header rev">
        <div>
          <div className="section-tag">{t.techStack.tag}</div>
          <h2 className="section-h">{t.techStack.title}</h2>
        </div>
        <p className="section-sub">{t.techStack.subtitle}</p>
      </div>

      <div className="tech-grid">
        {t.techStack.categories.map((cat, i) => (
          <div className={`tech-cat rev del-${i + 1}`} key={i}>
            <div className="tech-cat-label">{cat.label}</div>
            <h4>{cat.title}</h4>
            <div className="tech-list">
              {cat.items.map((item, j) => (
                <div className="tech-item" key={j}>{item}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TechStackSection;
